<script lang="ts">
  import { resolve } from '$app/paths'
  import { page } from '$app/state'
  import { helpPath, type HelpNode } from '$lib/help'
  import type { Tree } from '$lib/tree'
  import NavTree from './NavTree.svelte'

  interface Props {
    level?: number
    tree: Tree<HelpNode>
  }

  let { level = 0, tree }: Props = $props()
</script>

<ul class="level-{level}">
  {#each tree as post (post.full_slug)}
    <li>
      <a
        href={resolve(helpPath(post.full_slug))}
        class:active={page.params.slugs === post.full_slug}
      >
        {post.title}
      </a>
      {#if post.children.length > 0}
        <NavTree tree={post.children} level={level + 1} />
      {/if}
    </li>
  {/each}
</ul>

<style lang="postcss">
  ul {
    margin: 0;
    padding: 0;
    list-style: none;
    &.level-0 {
      > li:not(:first-child) {
        margin-top: 1rem;
      }
    }
    &:not(.level-0) {
      border-left: 1px solid var(--color-border);
      padding-top: 0.25rem;
      padding-left: 0.5rem;
      a {
        font-size: var(--scale-00);
      }
    }
    li {
      margin-bottom: 0.25rem;
    }
    a {
      color: var(--color-text-secondary);
      font-size: var(--scale-0);
      line-height: 110%;
      &.active {
        color: var(--color-text);
        font-weight: var(--weight-bold);
      }
    }
  }
</style>
